export default __webpack_public_path__ + "static/media/layer-low-local.f59d5c3d.svg";